import React, { PureComponent, Fragment } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Field } from "formik";

import FormikSemanticInput from "../FormikSemanticInput.jsx";
import FormikSemanticTextArea from "../FormikSemanticTextArea.jsx";

import { selectCopy } from "../../../../state/reducers/locale/copySelector.js";

class FormikDetailsPanel extends PureComponent {
  static propTypes = {
    id: PropTypes.string.isRequired,
    readOnly: PropTypes.bool.isRequired,
    disabled: PropTypes.bool.isRequired,
    apiErrors: PropTypes.object,
    copyKey: PropTypes.string.isRequired,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    id: "details",
    readOnly: false,
    disabled: false,
    copyKey: "forms.details_panel"
  };

  // -- RENDER -- //

  render() {
    const { readOnly, disabled, apiErrors, copyKey, copy } = this.props;

    return (
      <Fragment>
        <Field
          name={`name`}
          label={copy(`${copyKey}.name_input_label`)}
          placeholder={copy(`${copyKey}.name_input_placeholder`)}
          autoFocus={true}
          readOnly={readOnly}
          disabled={disabled}
          required={true}
          apiErrors={apiErrors}
          component={FormikSemanticInput}
        />
        <Field
          name={`description`}
          label={copy(`${copyKey}.description_input_label`)}
          placeholder={copy(`${copyKey}.description_input_placeholder`)}
          readOnly={readOnly}
          disabled={disabled}
          apiErrors={apiErrors}
          component={FormikSemanticTextArea}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(FormikDetailsPanel);
